import { IonButton } from '@ionic/react';
import { Component, ReactNode } from 'react';

import refreshIcon from '../../assets/icons/refresh.svg';
import { ErrorBoundaryContainer } from './style';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
  eventId: string | null;
}

class ErrorBoundaryComponent extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, eventId: null };
  }

  componentDidCatch(error: Error) {
    this.setState({ error });
    console.error('Error caught by boundary:', error);
  }

  render() {
    if (this.state.error) {
      //render fallback UI
      return (
        <ErrorBoundaryContainer>
          <div className="error-content">
            <p>Please click below to refresh the page</p>
            <IonButton className="refresh-button" onClick={() => window.location.reload()}>
              <div className="button-content">
                <img src={refreshIcon} alt="refresh" />
                <span>Refresh</span>
              </div>
            </IonButton>
            <p className="or-text">OR</p>
            <IonButton
              className="refresh-button"
              onClick={(e) => {
                e.preventDefault();
                try {
                  window.localStorage.clear();
                  window.sessionStorage.clear();
                } catch (error) {
                  console.warn('Failed to clear storage:', error);
                }
                window.location.href = '/connect';
              }}>
              <div className="button-content">
                <span>Logout</span>
              </div>
            </IonButton>
          </div>
        </ErrorBoundaryContainer>
      );
    } else {
      //when there's not an error, render children untouched
      return this.props.children;
    }
  }
}

export default ErrorBoundaryComponent;
